'use client';
import DynamicImage from '@/components/DynamicImage';
import { motion } from 'framer-motion';
import { icons } from 'lucide-react';
import { useEffect, useState } from 'react';
// import { AnimatedButton } from './common/AnimatedButton';
// import RegisDialog from './regisDialog';

const Contentfourmobile = () => {
  const items = [
    {
      tab: '营销获客',
      title: '渠道引流，持续获取新客户',
      id: 1,
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418182030/Frame%201312321278%402x.png',
      children: [
        {
          icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418887227/Frame%402x%20(45).png',
          title: '渠道活码：',
          dsc: '多渠道智能加粉，公域引流私域',
        },
        {
          icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418907048/Frame%20427319487%402x.png',
          title: '来源分析：',
          dsc: '统计客户来源渠道，分析效果',
        },
      ],
    },
    {
      tab: '客户管理',
      title: '客户管理 + 客户动态轨迹追踪',
      id: 2,
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418206596/Frame%201312321278%402x%20(2).png',
      children: [
        {
          icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418244769/Frame%402x%20(41).png',
          title: '客户画像:',
          dsc: '建立多维度画像，全生命周期管理',
        },
        {
          icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418330648/Frame%402x%20(42).png',
          title: '客户阶段:',
          dsc: '自定义客户所处阶段，赋能销售，促进成交',
        },
        {
          icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418350498/Frame%402x%20(43).png',
          title: '数据分析:',
          dsc: '通过数据分析，智能洞察客户行为偏好',
        },
      ],
    },
    {
      tab: '智能运营',
      title: '私域运营最佳策略，跟进客户更高效',
      dsc: '可为员工配置好友欢迎语，支持发送文字、图片及图文消息',
      id: 3,
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418507711/Frame%201312321278%402x%20(3).png',
      children: [
        {
          icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418528224/Frame%201312321054%402x.png',
          title: '客户群发',
          dsc: '内容互动，一键群发所有客户',
        },
        {
          icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418544324/Frame%201312321055%402x.png',
          title: '智能雷达',
          dsc: '智能记录客户访问动作，客户轨迹追踪+智能提醒，及时跟进重点商机',
        },
        {
          icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418561144/Frame%201312321057%402x.png',
          title: '客户SOP',
          dsc: '可创建自动化客户跟进SOP，员工一键发送，高效服务客户',
        },
      ],
    },
    {
      tab: '数据风控',
      title: '多维度数据风控，防止员工带走客户',
      dsc: '可为员工配置好友欢迎语，支持发送文字、图片及图文消息',
      id: 4,
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418603053/Frame%201312321278%402x%20(4).png',
      children: [
        {
          icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418645549/Frame%201312321058%402x.png',
          title: '离职继承: ',
          dsc: '员工离职，客户一键继承，防止员工带走客户',
        },
        {
          icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418663446/Frame%201312321059%402x.png',
          title: '流失提醒：',
          dsc: '客户删除员工提醒，及时挽回客户',
        },
        {
          icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418681419/Frame%402x%20(44).png',
          title: '会话存档：',
          dsc: '会话内容云端存档，满足企业合规审计要求',
        },
      ],
    },
  ];

  const [nowItem, setNowItem] = useState<any>({
    tab: '营销获客',
    title: '渠道引流，持续获取新客户',
    id: 1,
    icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418182030/Frame%201312321278%402x.png',
    children: [
      {
        icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418887227/Frame%402x%20(45).png',
        title: '渠道活码：',
        dsc: '多渠道智能加粉，公域引流私域',
      },
      {
        icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736418907048/Frame%20427319487%402x.png',
        title: '来源分析：',
        dsc: '统计客户来源渠道，分析效果',
      },
    ],
  });
  const setNowTab = (num: number) => {
    setNowItem(items[num]);
  };
  return (
    <section className="w-full px-[20px]">
      <motion.div
        className="text-center"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-[18px] mt-[32px] mb-[16px] font-medium text-black/85">
          微友智汇SCRM解决方案
        </h2>
        <div className="flex flex-col">
          <div className="overflow-x-auto h-[33px] scrollBar">
            <div className="flex w-[100vw]">
              {items.map((item, index) => (
                <p
                  key={index}
                  onClick={() => setNowTab(index)}
                  className={`mr-[10px] text-[14px] text-center leading-[30px] border-[1px] rounded-[4px] w-[85px] h-[32px] ${nowItem.id === item.id ? 'text-[#FF6700] border-[#FF6700]' : 'border-[rgba(0,0,0,0.06)] text-[rgba(0,0,0,0.45)]'}`}
                  style={{
                    background:
                      nowItem.id === item.id
                        ? 'linear-gradient( 318deg, #FFE3D0 0%, #FFF5DA 100%)'
                        : '',
                    boxShadow:
                      nowItem.id === item.id ? '0px 0px 15px 0px rgba(255,115,0,0.08)' : '',
                  }}
                >
                  {item.tab}
                </p>
              ))}
            </div>
          </div>
          <DynamicImage src={nowItem.icon} className="w-[100vw] h-[256px]"></DynamicImage>
          <p className="text-left relative">
            <span
              className="absolute w-[79px] z-[-1] h-[8px] bottom-0 left-0"
              style={{
                background: 'linear-gradient( 90deg, #FF6700 0%, rgba(255,103,0,0) 100%)',
              }}
            ></span>
            {nowItem.title}
          </p>
          <div className="pt-[16px]">
            {nowItem.children.map((item: any, index: number) => (
              <div key={index} className="flex text-[14px] mb-[14px] items-start">
                <DynamicImage
                  src={item.icon}
                  className="w-[24px] h-[24px] mr-[12px]"
                ></DynamicImage>
                <p className="text-left">
                  <span className="text-[rgba(0,0,0,0.85)]">{item.title}</span>
                  <span className="text-[rgba(0,0,0,0.75)]">{item.dsc}</span>
                </p>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Contentfourmobile;
